export default "__VITE_ASSET__C80A_apA__"